export const menus = [
  {
    name: "home",
    path: "/home",
  },
  {
    name: "services",
    menus: [
      {
        name: "One-on-One Coaching",
        path: "/one-on-one-coaching",
      },
      {
        name: "Group Workshops",
        path: "/group-workshops",
      },
      {
        name: "Self-Guided Courses",
        path: "/self-guided-courses",
      },
      {
        name: "Custom Wellness Plans",
        path: "/custom-wellness-plans",
      },
      {
        name: "Community Forums",
        path: "/community-forums",
      },
    ]
  },
  {
    name: "Find a Specialist",
    path: "/find-specialist",
    roles: ["member", "guest"],

  },
  {
    name: "Community",
    menus: [
      {
        name: "Forums",
        path: "/forums",
      },
      // {
      //   name: "Peer Support Groups",
      //   path: "/peer-support-groups",
      // },
      // {
      //   name: "Wellness Challenges",
      //   path: "/wellness-challenges",
      // },
    ]
  },
  {
    name: "Blogs",
    path: "/blogs",
    roles: ["member", "specialist"],
  },
  {
    name: "Webinars",
    path: "/webinars",
    roles: ["member", "specialist", "guest"],
  },
  {
    name: "pricing",
    path: "/pricing",
    roles: ["member", "guest"],
  },
  {
    name: "about us",
    menus: [
      {
        name: "Our Mission",
        path: "/our-mission"
      },
      {
        name: "Testimonials",
        path: "/testimonials"
      },
      {
        name: "FAQs",
        path: "/faqs"
      },
    ]
  },
  {
    name: "Help Centre ",
    path: "/help-center",
  },
]